<!-- page starts-->
    <section class="page-wrapper">
      <div class="checkout-top-section">
      	<div class="container">
      		<div class="checkout-top-detail cf">
      			<div class="checkout-top-detail-inner">
      				<div class="checkout-top-detail-content">
      					<p>A Northern Premier League match at Hurst Cross Stadium</p>
      				</div>
      				<div class="checkout-top-detail-team cf">
      					<div class="checkout-top-detail-team-left">
      						<div class="checkout-top-detail-team-left-content">
      							<div class="checkout-top-detail-team-left-content-inner">
	      							<h3>Ashton United</h3>
	      						</div>
      						</div>
      						<div class="checkout-top-detail-team-left-image">
      							<img src="assets/images/Bitmap-icon.png">
      						</div>
      					</div>
      					<div class="checkout-top-detail-team-center">
      						<div class="checkout-top-detail-team-center-inner">
	      						<h3>Home 15:00</h3>
	      						<p>Sat 17th of Oct</p>
	      					</div>
      					</div>
      					<div class="checkout-top-detail-team-right">
      						<div class="checkout-top-detail-team-left-image">
      							<img src="assets/images/avoid-image.png">
      						</div>
      						<div class="checkout-top-detail-team-left-content">
      							<div class="checkout-top-detail-team-left-content-inner">
	      							<h3>Radcliffe Borough</h3>
	      						</div>
      						</div>
      					</div>
      				</div>
      			</div>
      		</div>
      	</div>
      </div>
      <div class="checkout-center-section cf">
      	 <div class="container">
      	 	<div class="checkout-center-detail cf">
      	 		<div class="checkout-center-detail-left">
      	 			<div class="checkout-center-detail-address">
      	 				<div class="checkout-center-detail-address-titel">
      	 					<h2>Add Address</h2>
      	 				</div>
      	 				<div class="checkout-center-detail-address-content-box" style="" *ngFor="let address of addressList?.data">
      	 					<div class="checkout-center-detail-address-content">
	      	 					<h3>{{address?.city}}</h3>
	      	 					<p>{{address?.flat_house_no}}, {{address?.address1}} {{address?.address2}} {{address?.landmark}}{{address?.city}}{{address?.state}}{{address?.pincode}}{{address?.country}}</p>
      	 					</div>
      	 					<div class="checkout-center-detail-address-btn">
	      	 					<a href="#">Change Address or Add Address</a>
	      	 				</div>
      	 				</div>
      	 			</div>
      	 		</div>
      	 		<div class="checkout-center-detail-right">
      	 			<h2>Bookings Summary</h2>
      	 			<div class="checkout-center-detail-right-general-admission">
      	 				<h3>General Admission </h3>
      	 				<div class="checkout-center-detail-right-general-admission-detail cf">
      	 					<div class="checkout-center-detail-right-general-admission-name">
      	 						<p>Senior (Over 65) #112</p>
      	 						<p>Student</p>
      	 					</div>
      	 					<div class="checkout-center-detail-right-general-admission-number">
      	 						<p>2 Nos.</p>
      	 						<p>2 Nos.</p>
      	 					</div>
      	 					<div class="checkout-center-detail-right-general-admission-price">
      	 						<p>£20.00</p>
      	 						<p>£20.00</p>
      	 					</div>
      	 				</div>
      	 				<h3>Away Fans</h3>
      	 				<div class="checkout-center-detail-right-away-fans-detail">
      	 					<div class="checkout-center-detail-right-away-fans-content">
      	 						<p><span>Assigned to: John Smith </span><br><a href="#">johnsmith@gmail.com </a>| ASH0000843</p>
      	 						<p><span>Assigned to: John Smith </span><br><a href="#">johnsmith@gmail.com </a>| ASH0000843</p>
      	 					</div>
      	 					<div class="checkout-center-detail-right-away-fans-btn">
      	 						<p><a href="#">Edit Details</a></p>
      	 						<p><a href="#">Edit Details</a></p>
      	 					</div>
      	 				</div>
      	 				<div class="checkout-center-detail-code">
      	 					<div class="checkout-center-detail-code-voucher">
      	 						<a href="#">Apply voucher</a>
      	 					</div>
      	 					<div class="checkout-center-detail-code-box">
      	 						<a href="#">RR99EDU CODE</a>
      	 					</div>
      	 				</div>
      	 				<div class="checkout-center-detail-payment">
      	 					<div class="checkout-center-detail-payment-total">
      	 						<div class="checkout-payment-total">
      	 							<div class="checkout-payment-total-text">Total</div>
      	 							<div class="checkout-payment-total-price">£20.00</div>
      	 						</div>
      	 						<div class="checkout-payment-discount">
      	 							<div class="checkout-payment-discount-text">Order Discount</div>
      	 							<div class="checkout-payment-discount-price">£20.00</div>
      	 						</div>
      	 					</div>
      	 					<div class="checkout-payment-payable">
      	 						<div class="checkout-payment-payable-text">Payable Amount</div>
      	 						<div class="checkout-payment-payable-price">£20.00</div>
      	 					</div>
      	 					<div class="checkout-payment-payable-btn">
      	 						<a href="#">Confirm & Pay</a>
      	 					</div>
      	 				</div>
      	 			</div>
      	 		</div>
      	 	</div>
      	 	<div class="want-to-buy-season-tickets-section cf">
      	 		<div class="want-to-buy-season-tickets-left">
      	 			<h3>Want to buy Season Tickets?</h3>
      	 		</div>
      	 		<div class="want-to-buy-season-tickets-right">
      	 			<div class="want-to-buy-season-tickets-right-image">
      	 				<img src="assets/images/season-tickets.svg">
      	 			</div>
      	 		</div>
      	 	</div>
      	 </div>
      </div>
    </section><!-- page ends-->